import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const GET_PUBLIC_ANNOUNCEMENTS_KEY = 'get-public-announcements'

export const useGetPublicAnnouncements = () => {
    return useQuery({
        queryKey: [GET_PUBLIC_ANNOUNCEMENTS_KEY],
        queryFn: async () => {
            const response = await _apiClient.getPublicAnnouncements();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Pubilc Announcements.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
